module.exports = __webpack_public_path__ + "img/5_8.bebfe330.png";